import axios from "axios";
import { default as apiConfing } from "../config.json";
import { refresh } from "./accountService";
import { useHistory } from "react-router";
import { ONBORADING_SCREEN } from '../navigation/Constants.js'
import NiceModal from "@ebay/nice-modal-react";

const apiUrl = apiConfing.IS_DEVELOPMENT ? apiConfing.API_DEVELOPMENT : apiConfing.API_PRODUCTION;
let refreshing_token = null;



axios.interceptors.response.use((response) => {
   return response
}, async (error) => {
   const config = error.config;
   if (error.response && error.response.status === 401 && !config._retry) {
      config._retry = true;
      try {
         const auth = {
            accessToken: localStorage.getItem("token"),
            refreshToken: localStorage.getItem("refresh_token")
         }
         refreshing_token = refreshing_token ? refreshing_token : await refresh(auth);
         let res = refreshing_token;
         refreshing_token = null;
         if (res.data.accessToken) {
            localStorage.setItem("token", res.data.accessToken);
            localStorage.setItem("refresh_token", res.data.refreshToken);
            setJwt(res.data.accessToken);

         }
         config.headers['Authorization'] = `Bearer ${res.data.accessToken}`;
         return axios(config)
      }
      catch (err) {
         localStorage.removeItem("token");
         localStorage.removeItem("refresh_token");
         window.location.reload();
      }

   }
   return Promise.reject(error);
});

function setJwt(jwt) {
   axios.defaults.headers.common["Authorization"] = 'Bearer ' + jwt;
}



// eslint-disable-next-line import/no-anonymous-default-export
export default {
   get: axios.get,
   post: axios.post,
   put: axios.put,
   delete: axios.delete,
   patch: axios.patch,
   setJwt,
};
